<template>
  <div :style="style" class="scrollbar-wrapper">
    <div class="search-menu">
      <el-input placeholder="搜索内容" v-model="menuName" @input="searchMenu">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-menu ref="menuCollection" default-active="2" :class="{ sideStatus: !sideStatus }" :collapse="false" :collapse-transition="false"
      active-text-color="#5086FC" background-color="#ffffff" mode="vertical" text-color="#333"
      @select="(arg, arg1) => handleSelect(arg, arg1, 'collection')" class="el-menu-collection">
      <el-submenu index="1">
        <template slot="title">
          <img src="@/assets/images/menu/unCollect.png" />
          <span>常用功能</span>
        </template>
        <el-menu-item v-for="item in collectionList" :key="item.menuId" :index="item.menuId">
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <el-menu ref="mainMenu" :class="{ sideStatus: !sideStatus }" :collapse="false" :collapse-transition="false"
      :default-active="activeMenu" :unique-opened="launched" @select="handleSelect" active-text-color="#5086FC"
      background-color="#ffffff" mode="vertical" text-color="#333">
      <template v-for="route in menuList">
        <sidebar-item :activeId="activeMenu || activeSubMenu" :bageObj="bageObj" :item="route" :key="route.id"
          :nooType="account.nooType"
          v-if="route.title !== '智运账本' && route.title !== '智运账本部门专户' && route.title !== '公共功能' && !(route.title && route.title.indexOf('运费通') !== -1 && hideShowFreightLoan) && route.title !== '统计报表' && route.title !== '招投标' && route.title !== '交易通钱包'" />
      </template>
    </el-menu>
    <!-- <div class="mirror" v-if="!bubbleIdObj.bubbleId"></div> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { findSapState, findJddState, queryHaveOpen } from "@/services/ownerFreightloan/technicalServiceFee"
import SidebarItem from './SidebarItem'
// import menus from './menu'
import roleApi from '@/services/info/role'
export default {
  components: { SidebarItem },
  data () {
    return {
      activeMenu: '',
      isCollapse: false,
      bubbleIdObj: {},
      hideShowFreightLoan: true,
      //websocked相关
      webSocket: null, // ws实例
      IP: document.location.protocol == 'https' ? 'wss://crm.zczy56.com:/websocket-im' : 'ws://172.20.20.23:56789/websocket-im', // 测试环境
      // IP: 'ws://crm.zczy56.com:/websocket-im', // 生产环境
      lockReconnect: false, // 是否真正建立连接
      timeoutnum: null, // 断开 重连倒计时
      timeout: 5000, // 5秒一次心跳
      timeoutObj: null, // 心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      menuName: '',
      launched:true,
    }
  },
  computed: {
    ...mapGetters('log', ['currentMenus', 'activeSubMenu', 'primaryMenus', 'collectionList']),
    ...mapState('log', ['sideStatus', 'menuList', 'bageObj']),
    ...mapState('user', ['account']),
    style () {
      const width = '208px'
      return {
        width
      }
    }
  },
  watch: {
    currentMenus: {
      deep: true,
      handler (nv, ov) {
        this.setActive()
        this.getLeftMenuCornerMarker()
      }
    }
  },
  created () {
    this.getMenus()
    this.bubbleGuide()
    // 需求变更，此次pc先不做
    // this.wsInit();
  },
  methods: {
    ...mapMutations('log', [
      'setMenuList',
      'setActiveSubMenu',
      'setPermissionLists',
      'setBageObj',
      'setCollectionList'
    ]),
    ...mapActions('log', ['getLeftMenuCornerMarker']),

    bubbleGuide () {
      roleApi.bubbleGuide({ bubbleType: 1, businessFormat: 1 }).then(res => {
        if (res.code == 200) {
          this.$set(this.bubbleIdObj, 'bubbleId', res.data)
        }
      })
    },
    async getMenus () {
      let vm = this
      let menuList = []
      menuList = vm.menuRecursion(this.primaryMenus)

      // // 获取工行贷状态,京东贷状态
      // Promise.all([findJddState(),findSapState()]).then(res => {
      //     if (res[0].code == 200 || res[1].code == 200) {
      //         const data = res[0]
      //         const data1 = res[1].data
      //         if ((data1.sapApplyFlag == 1 && data1.applySapState == 8) || (data.jdApplyFlag == 1 && data.applyJdState == 2)) {
      //             // 展示
      //             this.hideShowFreightLoan = false
      //             vm.setMenuList(menuList)
      //         } else {
      //             // // 不展示
      //             // menuList = menuList.filter(item => item.title != "货主运费贷")
      //             // this.setMenuListData(menuList);
      //         }

      // 	} else {

      // 	}
      // })
      queryHaveOpen({}, { errHandler: false }).then(res => {
        // 展示
        this.hideShowFreightLoan = false
        vm.setMenuList(menuList)
      })
      this.setMenuListData(menuList);
    },
    setMenuListData (menuList) {
      let vm = this;
      vm.setMenuList(menuList)
      let currentMenuId = null
      currentMenuId = vm.getCurrentMenuId(menuList, vm.currentMenus.name)
      if (!currentMenuId) {
        currentMenuId = vm.currentMenus.id;
      }
      if (vm.currentMenus) {
        if (
          vm.currentMenus.name === 'primaryAccountNumber' &&
          vm.currentMenus.name !== 'myFortune'
        ) {
          vm.$router.push({
            path: '/publicPage/primaryAccountNumber'
          })
          return
        }
        if (vm.currentMenus.name === 'certificationUpgrade') {
          vm.$router.push({
            path: '/publicPage/certificationUpgrade',
            query: vm.currentMenus.query
          })
          return
        }
        if (!currentMenuId) {
          vm.$router.push({
            path: Vue.$config.home
          })
          return
        }
      }
      this.setActiveSubMenu(currentMenuId)
      this.activeMenu = currentMenuId
      // 权限
      // let res = await roleApi.selectUserPermissionList({})
      // if (res.code == 200) {
      // 	let permissionLists = res.data.map(item => item.perm)
      // 	if (permissionLists.length > 0) {
      // 		//
      // 		localStorage.setItem('permissionLists', permissionLists)
      // 		this.setPermissionLists(permissionLists)
      // 	}
      // }
      this.getLeftMenuCornerMarker()
      // } catch {
      // 	this.$message.warning('获取菜单失败，请联系管理员')
      // }
    },
    // 根据路由名字查找菜单id
    getCurrentMenuId (list, name) {
      let id = null
      list.forEach(it => {
        if (id) {
          return
        }
        if (it.name === name) {
          id = it.id
        } else if (it.children && it.children.length) {
          id = this.getCurrentMenuId(it.children, name)
        }
      })
      return id
    },
    menuRecursion (object) {
      let menuList = []
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const ele = object[key]
          // 因为统计下面的统计报表无法取消，其他系统有绑定该权限，所以在代码里面过滤掉此页面
          if (ele.url != 'waybillTatistics') {
            let newNode = {
              title: ele.name,
              icon: ele.icon,
              name: ele.url,
              id: ele.menuId
            }
            if (
              ele.children &&
              Array.isArray(ele.children) &&
              ele.children.length > 0
            ) {
              newNode.children = this.menuRecursion(ele.children)
            }
            menuList.push(newNode)
          }
        }
      }
      return menuList
    },
    resetMenus (list) {
      list.forEach(it => {
        it.id = it.menuId
        // if(it.subMenuList && it.subMenuList.length && it.subMenuList[0].type !== 2){
        // 	it.children = it.subMenuList;
        // 	this.resetMenus(it.subMenuList);
        // }
      })
    },
    setActive () {
      if (this.currentMenus) {
        this.activeMenu = this.currentMenus.id
      } else {
        this.activeMenu = ''
      }
    },
    handleSelect (id, indexPath, type) {
      let target = null;
      if (type == 'collection') {
        target = this.collectionList.find(it => it.menuId === indexPath[1])
      } else {
        target = this.menuList.find(it => it.id === indexPath[0])
      }
      let currentMenu = null
      if (target) {
        if (indexPath.length === 1 || type == 'collection') {
          currentMenu = target
        } else {
          const son = this.getCurrentMenu(target.children, id)
          currentMenu = son
        }
        let currentMenuId = currentMenu.menuId || currentMenu.id
        if (
          this.account &&
          this.account.userType === 6 &&
          currentMenu.url !== '/publicPage/myFortune' &&
          currentMenu.name !== 'myFortune'
        ) {
          this.$router.push('/publicPage/primaryAccountNumber')
        } else {
          if (currentMenu.url) {
            this.$router.push(currentMenu.url)
          } else {
            this.$router.push({
              name: currentMenu.name
            })
          }
        }
        if (this.activeMenu === currentMenuId) {
          this.$emit('on-reload')
        }
        this.activeMenu = currentMenuId
        this.setActiveSubMenu(currentMenuId)
      }
    },
    // 根据菜单id查找路由
    getCurrentMenu (list, id) {
      let son = null
      list.forEach(it => {
        if (son) {
          return
        }
        if (it.id === id) {
          son = it
        } else if (it.children && it.children.length) {
          son = this.getCurrentMenu(it.children, id)
        }
      })
      return son
    },
    //websocked相关
    wsInit () {
      if (typeof WebSocket === 'undefined') {
        this.$message.error('当前浏览器不支持scoket');
      } else {
        // 实例化socket
        this.webSocket = new WebSocket(this.IP);
        // 监听socket连接
        this.webSocket.onopen = this.onopen;
        // 监听socket错误信息
        this.webSocket.onerror = this.onerror;
        // 监听socket消息
        this.webSocket.onmessage = this.onmessage;
        this.webSocket.onclose = this.onclose;
      }
    },
    // 开启ws
    onopen () {
      console.log('ws建立连接成功');
      if (this.webSocket.readyState == 1) {
        // 初始化连接时需要调用的接口
        this.onsend();
        // 开启心跳
        this.start();
      }
    },
    onerror () {
      console.log('ws链接失败');
      this.reconnect();
      // this.wsInit();
    },
    onsend () {
      console.log('ws数据发送');
      let param = {
        userId: localStorage.getItem('uuUserId'),
        type: 'NEW_CONSIGNOR_PC',
      };
      try {
        this.webSocket.send(JSON.stringify(param));
      } catch (err) {
        console.log('send error', err);
      }
    },
    onmessage (res) {
      console.log(res, ' onmessage');
      const { data } = res;
      let msgDataObj = data == 'pong' ? 'pong' : JSON.parse(data);
      let receiveData = msgDataObj ? msgDataObj.msgData : null

      if (data == 'pong') {
        // 收到服务器信息，心跳重置
        this.reset();
      } else {
        // receiveData = [{"taskCount":1,"taskType":"301","taskTitle":"你有1个变更承运申请待处理","taskValue":"12462632567849","taskShow":true}];
        if (receiveData && receiveData instanceof Array) {
          /**
           *  违约管理角标数量                301
            获取待处理快递数                302
            发货单确认数量                  303
            查询运单异常数量                304
            待处理逾期                      305
            结算申请角标数量                306
            待补签合同数量                  307
            回单确认角标数量                308
           */
          //taskShow 表示是否展示的
          // 直接展示taskCount的值 
          let obj = {
            "301": 'breachApply',//违约管理角标
            "302": 'expressCount', //待处理快递数--回单签收
            "303": 'deliverOrderNum',//发货单确认数量
            "304": 'exceptionOrderCount',//	运单异常数量
            "305": 'orderOverDueCount',//	查询待处理逾期运单处理
            "306": 'applySettleCount', //结算申请角标数量
            "307": 'signatureCount',//待补签合同数量 
            "308": 'workOrder', //回单确认角标数量 
            "309": 'appointmentGuideCount' //外呼单角标
          }
          //结算申请角标数量和回单确认角标数量  本次先不推，还获取老数据
          let bageObj = {}
          receiveData.forEach(it => {
            if (it.taskShow) {
              bageObj[obj[it.taskType]] = it.taskCount
            }
          })
          this.setBageObj(bageObj)
        }
      }
    },
    // 断开
    onclose () {
      console.log('ws成功断开');
    },
    // 重置心跳
    reset () {
      var that = this;
      // 清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      // 重启心跳
      that.start();
    },
    // 重新链接
    reconnect () {
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        // 新连接
        // that.webSocket.close();
        that.wsInit();
        that.lockReconnect = false;
      }, 5000);
    },
    // 开启心跳
    start () {
      var that = this;
      that.timeoutObj && clearTimeout(that.timeoutObj);
      that.serverTimeoutObj && clearTimeout(that.serverTimeoutObj);
      that.timeoutObj = setTimeout(function () {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息（需要与后端沟通定义发送心跳机制）
        if (that.webSocket.readyState == 1) {
          // 如果连接正常
          that.webSocket.send('ping');
        }
        that.serverTimeoutObj = setTimeout(function () {
          // 超时关闭
          that.webSocket.close();
        }, that.timeout);
      }, that.timeout);
    },
    searchMenu () {
      this.$store.dispatch('log/searchMenu', this.menuName).then(() => {
        this.getMenus()
        this.bubbleGuide()
        if(this.menuName){
          this.launched=false;
          setTimeout(()=>{
               this.expandSubmenus(this.$refs.mainMenu,1);
           this.expandSubmenus(this.$refs.menuCollection,2);
          },500)
          
        }else{
          this.launched=true;
        }
       
      })
    },
     expandSubmenus(menuRef,type) {
      if (!menuRef) return;

      this._expand(menuRef,type);
    },
    _expand(menuRef,type) {
      let openeds=[];
      Object.keys(menuRef.submenus).forEach((key) => {
        openeds.push(key)
        // const submenu = menuRef.submenus[key];
        if(type==1 ){
          this.$refs.mainMenu.open(key)
        }else{
          this.$refs.menuCollection.open(key)
        }
        // if (submenu.submenus) {
        //   this._expand(submenu);
        // }
      });
      
    },
    // expandSubmenus(menuRef) {
    //   if (!menuRef) return;

    //    Object.keys(menuRef.submenus).forEach((key) => {
        
    //     menuRef.open(key);
       
    //   });
     
    // },
   
  },
  
  provide () {
    return {
      bubbleIdObj: this.bubbleIdObj
    }
  },
  beforeDestroy () {
    // 监听销毁
    console.log('监听销毁');
    this.webSocket.close();
  }
}
</script>

<style lang="scss">
.scrollbar-wrapper {
  transition: width 0.2s;
  height: 100%;
  width: 170px;
  background: #fff;
  box-shadow: 2px 0px 7px 0px rgba(48, 48, 82, 0.1);

  .sideStatus {
    .el-submenu__icon-arrow {
      display: none;
    }
  }

  .search-menu {
    padding: 8px;

    .el-input--small .el-input__inner {
      background-color: #F2F3F4;
    }

  }

  .el-menu-collection {
    .el-menu-item.is-active {
      background-color: transparent !important;
      border-right: 2px solid transparent;
      color: #333 !important;
    }
  }

  .el-menu {
    height: 100%;
  }

  /deep/.el-menu-item {
    padding-left: 12px;
  }

  .el-menu-item,
  .el-submenu {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    min-width: auto !important;

    img {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
  }

  .el-menu-item,
  .el-submenu__title {
    &:hover {
      background-color: #e7eeff !important;
      border-right: 2px solid #5086fc;
    }
  }

  .el-menu-item.is-active {
    background-color: #e7eeff !important;
    border-right: 2px solid #5086fc;
  }
}

.mirror {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>
